





































































































import {Component, Vue} from 'vue-property-decorator'
import DeviceInfoView from "@/view/device-manage/device/info.vue";
import DeviceTopicView from "@/view/device-manage/device/topic.vue";
import deviceModule from "@/store/module/DeviceModule";
import DevicePropStatusView from "@/view/device-manage/device/prop-status.vue";
import DeviceTaskWrapperView from "@/view/device-manage/device/task-wrapper.vue";
import DeviceShareView from "@/view/device-manage/device/share.vue";
import DeviceControlTmplView from "@/view/device-manage/device/control-tmpl.vue";
import DeviceDebugView from "@/view/device-manage/device/debug.vue";
import DeviceMqttEventView from "@/view/device-manage/device/mqtt-event.vue";
import DeviceMessageView from "@/view/device-manage/device/message.vue";
import SpanNullable from "@/component/Span/span-nullable.vue";
import {handleClipboard} from "@/util/clipboard";

@Component({
  components: {
    SpanNullable,
    DeviceInfoView,
    DeviceTopicView,
    DevicePropStatusView,
    DeviceTaskWrapperView,
    DeviceShareView,
    DeviceControlTmplView,
    DeviceDebugView,
    DeviceMqttEventView,
    DeviceMessageView,
  },
})
export default class DeviceDetailView extends Vue {

  private get device() {
    return deviceModule.active
  }

  private copy = handleClipboard
}
